import React from 'react';
import { Card, Table, Checkbox, Icon } from 'antd';
import { onGet, api } from '../../../../core/api3';

const { Column } = Table;

class QuantRobotLogCard extends React.Component {

    constructor() {
        super();
        this.state = {
            quantRobotLogs: [],
            pageNumber: 1,
            pageSize: 20,
            totalPage: 0,
            totalRow: 0,
            type: ['system', 'info', 'profit', 'trade', 'error']
        }
        this.loadData = this.loadData.bind(this);
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.getType = this.getType.bind(this);
        this.getContent = this.getContent.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let typeStr = '';
        this.state.type.forEach((type, index) => {
            if (index !== 0) {
                typeStr = typeStr + ',' + type;
            } else {
                typeStr = type;
            }
        })
        onGet(api.listQuantRobotLog.url, api.listQuantRobotLog.params(this.props.robotId, typeStr, this.state.pageNumber, this.state.pageSize)).then(response => {
            if (response === undefined) {
                return;
            }
            response.dataList.forEach(quantRobotLog => {
                quantRobotLog.key = quantRobotLog.id;
            });
            this.setState({
                quantRobotLogs: response.dataList,
                totalPage: this.state.pageNumber,
                totalRow: response.dataSize
            });
        });
    }

    onChangeCheckbox(type, checked) {
        let currentType = this.state.type;
        if (checked) {
            currentType.push(type);
        } else {
            currentType.forEach((t, index) => {
                if (t === type) {
                    currentType.splice(index, 1);
                }
            });
        }
        this.setState({ type: currentType }, () => {
            this.loadData();
        });
    }

    onChangePage(pageNumber) {
        this.setState({ pageNumber: pageNumber }, () => {
            this.loadData();
        });
    }

    getType(item) {
        if (item.type === 'system') {
            return <span style={{ color: '#FFFFFF', fontSize: 10, background: '#6C6C6C', paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderRadius: 5 }}>{item.typeDescribe}</span>
        } else if (item.type === 'info') {
            return <span style={{ color: '#FFFFFF', fontSize: 10, background: '#53B8D7', paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderRadius: 5 }}>{item.typeDescribe}</span>
        } else if (item.type === 'profit') {
            return <span style={{ color: '#F9F9F9', fontSize: 10, background: '#D34949', paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderRadius: 5 }}>{item.typeDescribe}</span>
        } else if (item.type === 'trade') {
            return <span style={{ color: '#FFFFFF', fontSize: 10, background: '#306FAB', paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderRadius: 5 }}>{item.typeDescribe}</span>
        } else if (item.type === 'error') {
            return <span style={{ color: '#D9D9D9', fontSize: 10, background: '#000000', paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderRadius: 5 }}>{item.typeDescribe}</span>
        }
        return <span>{item.typeDescribe}</span>
    }

    getContent(item) {
        if (item.type === 'profit') {
            return <span>{JSON.parse(item.extendData).profit}</span>;
        }
        if (item.type === 'trade') {
            let extendData = JSON.parse(item.extendData);
            if (extendData.cancel === true) {
                return <span style={{ color: '#FF0000' }}>撤单</span>;
            }
            let directionDescribe = '';
            if (extendData.direction.toLowerCase() === 'buy') {
                if (extendData.side.toLowerCase() === 'long') {
                    directionDescribe = '开多';
                } else if (extendData.side.toLowerCase() === 'short') {
                    directionDescribe = '平空';
                }
            } else if (extendData.direction.toLowerCase() === 'sell') {
                if (extendData.side.toLowerCase() === 'short') {
                    directionDescribe = '开空';
                } else if (extendData.side.toLowerCase() === 'long') {
                    directionDescribe = '平多';
                }
            }
            return <span>{directionDescribe + ' => ' + ('价格：' + (extendData.price === -1 ? '市价' : extendData.price)) + '，数量：' + extendData.volume}</span>;
        }
        if (item.type === 'error') {
            return <span style={{ color: '#000000' }}>{item.content}</span>;
        }
        if (item.behavior === undefined) {
            return <span>{item.content}</span>;
        }
        let behaviorSplitArray = item.behavior.split(' ');
        if (behaviorSplitArray.length === 1) {
            return <span style={{ color: behaviorSplitArray[0] }}>{item.content}</span>
        }
        return <span style={{ color: behaviorSplitArray[0] }}>{item.content + ' '}<Icon type="notification" /></span>
    }

    render() {
        return (
            <div>
                <Card title="日志信息" bordered={false} >
                    <div style={{ marginBottom: 24 }}>
                        <Checkbox onChange={e => this.onChangeCheckbox('system', e.target.checked)} defaultChecked="true">系统</Checkbox>
                        <Checkbox onChange={e => this.onChangeCheckbox('info', e.target.checked)} defaultChecked="true">信息</Checkbox>
                        <Checkbox onChange={e => this.onChangeCheckbox('profit', e.target.checked)} defaultChecked="true">收益</Checkbox>
                        <Checkbox onChange={e => this.onChangeCheckbox('trade', e.target.checked)} defaultChecked="true">交易</Checkbox>
                        <Checkbox onChange={e => this.onChangeCheckbox('error', e.target.checked)} defaultChecked="true">错误</Checkbox>
                    </div>
                    <Table dataSource={this.state.quantRobotLogs} pagination={{
                        current: this.state.pageNumber, total: this.state.totalRow, defaultPageSize: this.state.pageSize,
                        onChange: pageNumber => { this.onChangePage(pageNumber) },

                    }}>
                        <Column title="时间" width="15%" dataIndex="createTime" align="center" />
                        <Column title="类型" width="15%" align="center" render={item => this.getType(item)} />
                        <Column title="信息" align="left" render={item => this.getContent(item)} />
                    </Table>
                </Card>
            </div>
        );
    }

}

export default QuantRobotLogCard;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/quant/QuantRobotLogCard.jsx